import dayjs from 'dayjs'

export interface TaskUnlockConfig {
  unlockMode: number | string
  unlockUnit: number | string
  modeType?: number | string
  startStudyTime?: string
  intervalDays?: number | string
}

export const isTimeUnlockMode = (config: TaskUnlockConfig) => Number(config.unlockMode) === 3

export const isStageTimeLocked = (stage: any, config: TaskUnlockConfig) => {
  if (!isTimeUnlockMode(config)) return false
  if (Number(config.unlockUnit) === 2) {
    return stage?.isLocked === true || stage?.isLocked === 1
  }
  return false
}

export const isTaskTimeLocked = (task: any, stage: any, config: TaskUnlockConfig) => {
  if (!isTimeUnlockMode(config)) return false
  if (Number(config.unlockUnit) === 2) {
    return stage?.isLocked === true || stage?.isLocked === 1
  }
  if (Number(config.unlockUnit) === 1) {
    return task?.isLocked === true || task?.isLocked === 1
  }
  return false
}

export const getTaskUnlockTime = (task: any, stage: any, config: TaskUnlockConfig): string => {
  if (Number(config.unlockUnit) === 2) {
    return stage?.unlockTime || ''
  }
  if (Number(config.unlockUnit) === 1) {
    if (task?.unlockTime) return task.unlockTime
    if (Number(config.modeType) === 1 && config.startStudyTime && config.intervalDays != null) {
      const days = (task?.globalIndex || 0) * Number(config.intervalDays)
      return dayjs(config.startStudyTime).add(days, 'day').format('YYYY-MM-DD HH:mm:ss')
    }
  }
  return ''
}

export const formatUnlockTime = (timeStr: string): string => {
  if (!timeStr) return ''
  return dayjs(timeStr).format('YYYY-MM-DD HH:mm:ss')
}
